export default __webpack_public_path__ + "static/media/00.98aafb88.png";